<h2 mat-dialog-title class="w-100 text-center primary-color"><b>{{title}}</b></h2>
<mat-dialog-content [formGroup]="presetDefaultsForm">
  <div class="text-md w-100 text-center text-bold mb-2" [formGroup]="presetDefaultsForm">Set the default value for Presets. Values can be changed in the moov configuration if needed.</div>
  <div formArrayName="presets" class="flex-col items-center w-100">
    @for (preset of presetsArray; track $index; let i = $index; let isLast = $last) {
      <div [formGroupName]="i" class="w-100">
        @if (preset.value.inputType==='slt') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic"  class="w-100">
            <mat-label>{{preset.value.name}}</mat-label>
            <input matInput formControlName="value" autocomplete="off" type="text">
          </mat-form-field>
        }
        @else if (preset.value.inputType==='mlt') {
          <mat-form-field  class="w-100" subscriptSizing="dynamic"  appearance="outline">
            <mat-label>{{preset.value.name}}</mat-label>
            <textarea matInput formControlName="value" autocomplete="off" cdkTextareaAutosize  cdkAutosizeMinRows="4"> </textarea>
          </mat-form-field >
        }
        @else if (preset.value.inputType==='num') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic"  class="w-100">
            <mat-label>{{preset.value.name}}</mat-label>
            <input matInput formControlName="value" autocomplete="off" type="number" onlyNumber step="1">
          </mat-form-field>
        }
        @else if (preset.value.inputType==='sel') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic"  class="w-100">
            <mat-label>{{preset.value.name}}</mat-label>
            <mat-select #i [placeholder]="preset.value.name" formControlName="value">
              <div (mouseleave)="i.close()">
                <mat-option [value]="undefined"><i>Clear</i></mat-option>
                @for (option of getPresetOptions(preset.value.name); track $index; let optionIndex = $index) {
                  <mat-option [value]="option">
                    {{option}}
                  </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        }
        @else if (preset.value.inputType==='msel') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic"  class="w-100">
            <mat-label>{{preset.value.name}}</mat-label>
            <mat-select #i [placeholder]="preset.value.name" formControlName="value" multiple>
              <div (mouseleave)="i.close()">
                @for (option of getPresetOptions(preset.value.name); track $index; let optionIndex = $index) {
                  <mat-option [value]="option">
                    {{option}}
                  </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        }
        @else if (preset.value.inputType==='eml') {
          <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{preset.value.name}}</mat-label>
            <input matInput formControlName="value" autocomplete="off" type="email" multiple>
            @if (preset.get('value')?.hasError('invalidEmail')) { <mat-error>Invalid email address</mat-error> }
          </mat-form-field>
        }
        @else if (preset.value.inputType==='bool') {
          <mat-slide-toggle [checked]="preset.value.value === 'true' ? true : false" (change)="onBooleanPresetChanged(preset,$event)" class="mb-5" labelPosition="before" color="primary"><span class="text-md">{{preset.value.name}}</span></mat-slide-toggle>
        }
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row space-between items-center">
    <a mat-button color="primary" (click)="onCancelClick()">{{cancelButtonText}}</a>
    <button mat-flat-button color="primary" [disabled]="!canSubmit" (click)="onSubmitClick()">{{submitButtonText}}</button>
  </div>
</mat-dialog-actions>